<svelte:options customElement="cv-tab-body" />

<script lang="ts">
  // No logic needed, just a container
</script>

<slot></slot>

<style>
  :host {
    display: block;
  }
</style>
